<template>
  <div class="container-fluid new_Header">
    <div class="row nav_Breadcrumb">
      <div class="col">
        <nav>
          <ol class="breadcrumb">
            <li class="breadcrumb-item mx-3 pt-1"><router-link  to="/">{{$t('propertyrequest.breadcrumb_1')}}</router-link></li>
            <i  v-if="userLang == 'ar'" class="fa-solid fa-chevron-left padding-t-9"></i>
            <i  v-else class="fa-solid fa-chevron-right padding-t-9"></i>
            <li class="breadcrumb-item mx-3 font-20 almarai-bold" aria-current="page">
              {{$t('propertyrequest.breadcrumb_2')}}
            </li>
          </ol>
        </nav>
      </div>
    </div>
  </div>
  <div class="container pt-3">
    <errorAlert v-if="hasError" :alertMessage="message" :errorNumber="errorNumber"/>

    <div class="row justify-content-center" v-if="step == 1">
      <div class="col-12 col-md-8"> 
          <div class="card propertyRequest">
            <div class="card-body">
              <form action="">
                <div class="row">
                  <div class="col-12 col-md-6">
                    <label for="" class="small-Font padding-Bottom"> 
                      {{$t('propertyrequest.title_1')}} <span class="stars">*</span>
                    </label>
                    <Select2
                      :placeholder="$t('home.ft_5')"
                      class="mouse-hand form-select input-style pe-5 fonttext-14 style-form-select"
                      v-model="regionId"
                      :options="regionsObj"
                      :settings="select2Settings"
                      @select="citiesList()"
                    ></Select2>
                    <!-- <select v-model="regionId" @change="citiesList" class="mouse-hand form-select input-style pe-5 fonttext-14">
                      <option v-for="(region,index) in regions" :key="index" :value="region.id">{{ region.name }}</option>
                    </select> -->
                  </div>
                  <div class="col-12 col-md-6 max-margin">
                    <label for="" class="small-Font">
                      {{$t('propertyrequest.title_2')}} <span class="stars">*</span>
                    </label>
                    <Select2
                      :placeholder="$t('home.ft_6')"
                      class="mouse-hand form-select input-style pe-5 fonttext-14 style-form-select"
                      :modelValue="city"
                      v-model="city"
                      @click="checkRegions"
                      :options="cityObj"
                      @select="neighborhoodList()"
                    ></Select2>
                    <!-- <select v-model="city" @change="neighborhoodList" @click="checkRegions"  class="mouse-hand form-select input-style pe-5 fonttext-14">
                      <option v-for="(row,index) in rows" :key="index" :value="row.id">{{ row.name }}</option>
                    </select> -->
                  </div>
                  <!-- <div class="error-feedback red-color fonttext-14" v-if="validate.city.$error">
                    {{ validateMessage }}
                  </div> -->
                </div>
                <div class="error-feedback red-color fonttext-14" v-if="validate.regionId.$error">
                  {{ validateMessage }}
                </div>
                <div class="row pt-3">
                  <div class="col-12 col-md-6">
                    <label for="" class="small-Font">
                      {{$t('propertyrequest.title_3')}} <span class="stars">*</span>
                      </label>
                      <Select2
                        class="mouse-hand form-select input-style pe-5 fonttext-14 style-form-select"
                        modelValue="neighborhood"
                        v-model="neighborhood"
                        @click="checkNeighborhoods"
                        :placeholder="$t('home.ft_7')"
                        :options="itemsOb"
                      ></Select2>
                    <!-- <select v-model="neighborhood" @click="checkNeighborhoods" class=" mouse-hand form-select input-style pe-5 fonttext-14">
                      <option v-for="(item,indx) in items" :key="indx" :value="item.id">{{item.name}}</option>
                    </select> -->
                  </div>
                  <div class="col-12 col-md-6 max-margin">
                    <label class="small-Font">
                    {{$t('propertyrequest.title_4')}} <span class="stars">*</span>
                    </label>
                    <Select2
                      class="mouse-hand form-select input-style pe-5 fonttext-14 style-form-select"
                      modelValue="type_Id"
                      v-model="type_Id"
                      :placeholder="$t('home.ft_8')"
                      :options="typeObj"
                      @select="manageFields"
                    ></Select2>
                    <!-- <select v-model="type_Id" @change="manageFields" class="mouse-hand form-select input-style pe-5 fonttext-14" aria-label="Default select example">
                      <option v-for="(val,inde) in types" :key="inde" :value="val.id">{{val.name}}</option>
                    </select> -->
                  </div>
                </div>
                <div class="error-feedback red-color fonttext-14" v-if="validate.type_Id.$error">
                  {{ validateMessage }}
                </div>

                <div class="row pt-3">
                  <div class="col-12 col-md-6">
                    <label  class="small-Font">{{$t('propertyrequest.title_16')}}</label>
                    <select class="form-select input-style" v-model="age" aria-label="Default select example">
                      <!-- <option selected>اختر مدة عمر العقار</option> -->
                      <option v-for="(list, index) in agesList" :key="index" :value="list.id">{{list.name}}</option>
                    </select>
                  </div>
                  <div class="col-12 col-md-6">
                    <div class="row">
                      <label class="small-Font">
                        {{$t('propertyrequest.title_5')}} <span class="stars">*</span>
                      </label>
                      <div class="col-6">
                        <label for="sales" class=" mouse-hand">
                          <div :class="(purpo == 'for_sale') ? 'div-style text-center button-bg' : 'div-style text-center'">
                            <input class="form-check-input d-none" type="radio" v-model="purpo"  value="for_sale" name="flexn" id="sales">
                            <span>{{$t('propertyrequest.title_6')}}</span>
                          </div>
                        </label>
                      </div>
                      <div class="col-6">
                        <label for="rent" class="mouse-hand">
                          <div :class="(purpo == 'for_rent') ? 'div-style text-center button-bg' : 'div-style text-center'">
                            <input class="form-check-input d-none" type="radio" v-model="purpo"  value="for_rent" name="flexn" id="rent">
                            <span>{{$t('propertyrequest.title_7')}}</span>
                          </div>
                        </label>
                      </div>
                    </div>
                    <div class="error-feedback red-color fonttext-14" v-if="validate.purpo.$error">
                      {{ validateMessage }}
                    </div>
                  </div>
                </div>

                <div class="row pt-3">
                  <div class="col-12 col-md-6 content-center" v-if="showFurnished">
                    <div class="row">
                      <label for="" class="small-Font">{{$t('furnished')}}</label>
                      <div class="col-6">
                        <label for="true">
                          <div :class="(Furnished == 'true') ? 'div-style text-center button-bg mouse-hand' : 'div-style text-center mouse-hand'">
                            <input type="radio" v-model="Furnished" class="form-check-input d-none" value="true" id="true">
                            <span>{{$t('addAd.yes')}}</span>
                          </div>
                        </label>
                      </div>
                      <div class="col-6">
                        <label for="false">
                          <div :class="(Furnished == 'false') ? 'div-style text-center button-bg mouse-hand' : 'div-style text-center mouse-hand'">
                            <input type="radio" v-model="Furnished" value="false" class="form-check-input d-none" id="false">
                            <span>{{$t('addAd.no')}}</span>
                          </div>
                        </label>
                      </div>
                    </div>
                  </div>

                  <div class="col-12 col-md-6 max-margin content-center" v-if="showPropertyType">
                    <div class="row">
                      <label class="small-Font">
                        {{$t('propertyrequest.title_11')}} 
                      </label>
                      <div class="col-6">
                        <label for="single">
                          <div :class="(propertyType == 'singles') ? 'div-style text-center button-bg mouse-hand' : 'div-style text-center mouse-hand'">
                            <input type="radio" v-model="propertyType" class="form-check-input d-none" value="singles" id="single">
                            <span>{{$t('propertyrequest.title_12')}}</span>
                          </div>
                        </label>
                      </div>
                      <div class="col-6">
                        <label for="familie">
                          <div :class="(propertyType == 'families') ? 'div-style text-center button-bg mouse-hand' : 'div-style text-center mouse-hand'">
                            <input type="radio" v-model="propertyType" value="families" class="form-check-input d-none" id="familie">
                            <span>{{$t('propertyrequest.title_13')}}</span>
                          </div>
                        </label>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row pt-2 mouse-hand">
                  <!-- <span class="fonttext-14 gray-color almarai-regular ">{{$t('propertyrequest.title_8')}}</span> -->
                  <div class="col-6">
                    <label class="fonttext-14 gray-color almarai-regular " >{{$t('propertyrequest.title_9')}}</label>
                    <input type="text" maxlength="10" @input="formatNumber" v-model="lowestPrice" value="lowerP" class="form-control input-style"  id="lower">
                  </div>
                  <div class="col-6">
                    <label class="fonttext-14 gray-color almarai-regular ">{{$t('propertyrequest.title_10')}}</label>
                    <input type="text" maxlength="10" @input="priceFormating" v-model="highesPrice" class="form-control input-style"  id="highest">
                  </div>
                </div>

                <div class="row pt-3 mouse-hand">
                  <span class="fonttext-14 gray-color almarai-regular pb-2">{{$t('propertyrequest.area')}} {{$t('areaSymbol')}}</span>
                  <div class="col-6">
                    <input type="text" maxlength="10" :placeholder="$t('from')" @input="formatNumber" v-model="area" value="lowerP" class="form-control input-style"  id="lower">
                  </div>
                  <div class="col-6">
                    <input type="text" maxlength="10" :placeholder="$t('to')" @input="priceFormating" v-model="areaTo" class="form-control input-style"  id="highest">
                  </div>
                </div>

                <div class="row pt-3 furnished">
                  <div class="col-12 col-md-6" v-if="showRoomsCount">
                    <div class="row pt-2">
                      <div class="col-12">
                        <label  class="fonttext-14 gray-color almarai-regular">{{$t('propertyrequest.title_14')}}</label>
                        <input type="number" class="form-control input-style" v-model="roomsCount">
                      </div>
                    </div>
                  </div>
                </div>
                
                <div class="row pt-3">
                  <span class="fonttext-14 gray-color almarai-regular pb-2">{{$t('propertyrequest.details')}}</span>
                  <div class="col">
                    <textarea  rows="4" v-model="extraDetails" class="form-control br-radius-16" :placeholder="$t('propertyrequest.explain_Details')"></textarea>
                  </div>
                </div>

                <!-- <div class="row pt-3">
                  <div class="col-6 pt-2" v-if="showFloorNumber">
                    <label  class="fonttext-14 gray-color almarai-regular">{{$t('propertyrequest.title_15')}}</label>
                    <input type="number" v-model="floorNumber" class="form-control input-style">
                  </div>
                </div> -->

                <div class="row pt-3">
                  <div class="col-auto">
                    <div class="btn-green" data-bs-toggle="modal" data-bs-target="#exampleModal">
                      <i class="bi bi-file-earmark-plus"></i>
                      <span class="mx-2">{{$t('propertyrequest.title_17')}}</span>
                    </div>
                  </div>
                </div>

                <div class="row pt-3">
                  <div class="col-auto" v-for="(item,index) in showFeatures" :key="index">
                    <div>
                      <img :src="MEDIA_URL+item.icon" class="max-width-28" alt="">
                      {{item.name}} 
                    </div>
                  </div>
                </div>

                <div class="row pt-3 mouse-hand justify-content-center">
                  <div class="col-11 col-md-6 mb-3">
                    <div v-if="isLoading" class="text-center">
                      <loader />
                    </div>
                    <div v-else @click.prevent="createRquest" class="btn-green">
                      {{$t('propertyrequest.title_18')}}
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>

      </div>
    </div>
    <!--begin:modalFeatures -->
    <div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog max-w">
        <div class="modal-content">
          <button type="button" class="btn-close p-3"  data-bs-dismiss="modal" aria-label="Close"></button>
          <div class="modal-body">
            <div class="row pt-3" v-for="(feature ,index) in featuresList" :key="index">
              <span class="almarai-bold py-2">{{feature.category }} </span>
              <div class="col-6 col-md-6 col-lg-4 button-center py-2" v-for="(feature ,indx) in featuresList[index].features" :key="indx" >
                <div class="form-check p-0 d-flex">
                  <input class="form-check-input mx-2" @change="selectFeatures()" type="checkbox" v-model="features" :value="feature.id" :id="feature.id">
                  <label class="form-check-label" :for="feature.id">
                    <img :src="MEDIA_URL+feature.icon" class="max-width-28" alt="">
                    <span class="mx-1 fonttext-14"> {{feature.name }}</span>
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <div class="ms-auto features-button" data-bs-dismiss="modal">{{$t('propertyrequest.title_27')}}</div>
          </div>
        </div>
      </div>
    </div>
    <!--end: Property Features-->

    <!--begin:property request added successfully-->
    <div class="row pt-3" v-if="step == 2">
      <div class="col">
        <div class="row">
          <div class="col text-center">
            <div><img src="/assets/images/tick-circle.png" class="width-48" alt=""></div>
          </div>
        </div>

        <div class="row pt-4">
          <div class="col text-center">
            <h4 class="almarai-bold font-24">{{$t('propertyrequest.title_19')}}</h4>
          </div>
        </div>

        <div class="row pt-2">
          <div class="col gray-color text-center almarai-regular">
            <!-- <p>{{$t('propertyrequest.title_20')}} <br> {{$t('propertyrequest.title_21')}}</p> -->
            <p>{{$t('propertyrequest.newTitle')}}</p>
          </div>
        </div>

        <div class="row pt-3 justify-content-center">
          <div class="col-12 col-md-6">
            <router-link to="/">
              <div class="submit-button text-center almarai-bold">{{$t('propertyrequest.title_22')}}</div>
            </router-link>
          </div>
        </div>
      </div>
    </div>
    <!--end:property request added successfully-->


    <div class="modal bg-modal" id="selectRegion" tabindex="-1">
      <div class="modal-dialog">
        <div class="modal-content">
          <!-- <div class="modal-header">
            <h5 class="modal-title">Modal title</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div> -->
          <div class="modal-body">
            <div class="row justify-content-center">
              <div class="col text-center">
                <img src="/assets/images/icons/Error.png" class="width-48" alt="">
              </div>
            </div>
            <div class="row justify-content-center pt-3">
              <div class="col text-center">
                <p class="mb-1 almarai-bold">{{$t('errorOccurred')}}</p>
                <h6 class="small-Font">{{$t('regionFirst')}}</h6>
              </div>
            </div>

            <div class="row pt-3 justify-content-center">
              <div class="col-8 text-center mouse-hand text-white">
                <div class="btn-green" @click="closePopup" >{{$t('continuation')}}</div>
              </div>
            </div>
          </div>
          <!-- <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
            <button type="button" class="btn btn-primary">Save changes</button>
          </div> -->
        </div>
      </div>
    </div>

    <div class="modal bg-modal" id="selectNeighborhoods" tabindex="-1">
      <div class="modal-dialog">
        <div class="modal-content">
          <!-- <div class="modal-header">
            <h5 class="modal-title">Modal title</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div> -->
          <div class="modal-body">
            <div class="row justify-content-center">
              <div class="col text-center">
                <img src="/assets/images/icons/Error.png" class="width-48" alt="">
              </div>
            </div>
            <div class="row justify-content-center pt-3">
              <div class="col text-center">
                <p class="mb-1 almarai-bold">{{$t('errorOccurred')}}</p>
                <h6 class="small-Font">{{$t('cityFirst')}}</h6>
              </div>
            </div>

            <div class="row pt-3 justify-content-center">
              <div class="col-8 text-center mouse-hand text-white">
                <div class="btn-green" @click="exit" >{{$t('continuation')}}</div>
              </div>
            </div>
          </div>
          <!-- <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
            <button type="button" class="btn btn-primary">Save changes</button>
          </div> -->
        </div>
      </div>
    </div>

  </div>
</template>
<script>
import { useVuelidate } from '@vuelidate/core';
import { required } from '@vuelidate/validators';
import { mapGetters } from 'vuex';
export default {
  name: "propertyrequest",

  setup(){
    return { validate: useVuelidate() }
  },

  data(){
    return{
      step: 1,
      hasError: false,
      message: "",
      isLoading: false,
      regionId: null,
      city: null,
      neighborhood: null,
      type_Id: null,
      purpo: "",
      highesPrice: null,
      lowestPrice: null,
      propertyType: "",
      roomsCount: null,
      age: null,
      floorNumber: null,
      regions: [],
      rows: [],
      items: [],
      types: [],
      featuresList: [],
      features: [],
      errorNumber: null,
      userLang: 'ar',
      validateMessage: this.$t('validateMessage'),
      showFeatures: [],
      Furnished: '',
      agesList: [],
      showPropertyType: false,
      showRoomsCount: false,
      showFloorNumber: false,
      showFurnished: false,
      area: null,
      areaTo: null,
      extraDetails: "",
      regionsObj: [],
      cityObj: [],
      itemsOb: [],
      typeObj: [],
      // showBuildNumber: false,
      // showFloorsCount : false,
      // showBathrooms: false,
      // showAge : false,
    }
  },
  computed:{
    ...mapGetters(['MEDIA_URL'])
  },

  validations (){
    return {
      purpo: {required},
      regionId: {required},
      city: {required},
      type_Id: {required},
      // propertyType: {required},
    }
  },

  methods: {
    getDataInit(){
      this.hasError = false;
      this.$http.get("/api/properties/init").then(res => {
        // console.log(res);
        this.regions = res.data.regionsList;
        this.types = res.data.typesList;
        this.featuresList = res.data.featuresList;
        this.agesList = res.data.agesList;
        let propertyArray = [];
        for (let p = 0; p < this.types.length; p++) {
          propertyArray.push({
            id: this.types[p].id,
            text: this.types[p].name,
          });
        }
        this.typeObj = propertyArray;
        let regionOption = [];
        for (let R = 0; R < this.regions.length; R++) {
          regionOption.push({
            id: this.regions[R].id,
            text: this.regions[R].name,
          });
        }
        this.regionsObj = regionOption;
        this.dataLoading = false;  
        window.scroll(0,0);
      }).catch(err => {
        // console.log(err);
        this.dataLoading = false;
        this.message = this.$globalError(err);
        this.hasError = true;
      });
    },

    citiesList(){
      this.hasError = false;
      this.$http.get("/api/cities/list?regionId="+this.regionId).then(res => {
        // console.log(res);
        this.rows = res.data.cities;
        let cityOptions = [];
        for (let i = 0; i < this.rows.length; i++) {
          cityOptions.push({ id: this.rows[i].id, text: this.rows[i].name });
        }
        this.cityObj = cityOptions;
        this.loading = false;
      }).catch(err => {
        // console.log(err);
        this.message = this.$globalError(err);
        this.hasError = true;
      });
    },

    neighborhoodList(){
      this.hasError = false;
      this.$http.get("/api/neighborhoods/list?cityId="+this.city).then(res => {
        // console.log(res);
        this.items = res.data.neighborhoods;
        let optionsArray = [];
        for (let i = 0; i < this.items.length; i++) {
          optionsArray.push({
            id: this.items[i].id,
            text: this.items[i].name,
          });
        }
        this.itemsOb = optionsArray;
        this.loader = false;
      }).catch(err => {
        // console.log(err);
        this.message = this.$globalError(err);
        this.hasError = true;
      })
    },

    async createRquest(){
      const valid = await this.validate.$validate();
      if(!valid){
        window.scroll(0,0);
        return false;
      }
      this.hasError = false;
      this.isLoading = true;
      this.$http.post("/api/propertyRequests/create",{
        purpose: this.purpo,
        regionId: this.regionId,
        cityId: this.city,
        neighborhoodId: this.neighborhood,
        typeId: this.type_Id,
        priceFrom: parseInt(this.highesPrice),
        priceTo: parseInt(this.lowestPrice),
        propertyType: this.propertyType,
        roomsCount: this.roomsCount,
        age: parseInt(this.age),
        features: this.features,
        area: this.area,
        areaTo: this.areaTo,
        extraDetails: this.extraDetails,
      }).then(res => {
        // console.log(res);
        this.isLoading = false;
        this.step = 2;
      }).catch(err => {
        // console.log(err);
        this.isLoading = false;
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
        window.scrollTo({ top: 0, behavior: 'smooth'});
      });
    },
    // restValue(){
    //   this.features = [];
    // },

    selectFeatures(){
      this.showFeatures = [];
      for (let i = 0; i < this.featuresList.length; i++) {
        for(let d= 0; d< this.featuresList[i].features.length; d++){
          if(this.features.indexOf(this.featuresList[i].features[d].id) != -1){
            this.showFeatures.push(this.featuresList[i].features[d]);
          }
        }
      }
    },

    formatNumber() {
      // امسح أي حروف غير أرقام
      let raw = this.lowestPrice.replace(/,/g, "").replace(/\D/g, "");

      // لو فاضي — رجّعه
      if (!raw) {
        this.lowestPrice = "";
        return;
      }
      // إضافة الفواصل كل 3 أرقام
      this.lowestPrice = Number(raw).toLocaleString("en-US");
    },

    priceFormating(){
      let highPrice = this.highesPrice.replace(/,/g, "").replace(/\D/g, "");
      // لو فاضي — رجّعه
      if (!highPrice) {
        this.highesPrice = "";
        return;
      }
      // إضافة الفواصل كل 3 أرقام
      this.highesPrice = Number(highPrice).toLocaleString("en-US");
    },

    manageFields(){
      this.showPropertyType = false;
      this.showRoomsCount = false;
      this.showFloorNumber = false;
      this.showFurnished = false;

      // this.showBuildNumber = false;
      // this.showFloorsCount = false;
      // this.showBathrooms = false;
      // this.showAge = false;

      this.propertyType = null;
      this.roomsCount = null;
      this.floorNumber = null;
      this.Furnished = '';
      
      // this.floorsCount = null;
      // this.apartmentNumber = null;
      // this.bathrooms = null;
      // this.age = null;
      if(this.type_Id){
        for(let i=0; i < this.types.length; i++) {
          if(this.types[i].id == this.type_Id) {
            if(this.types[i].propertyFields && this.types[i].propertyFields.indexOf("propertyType") != -1){
              this.showPropertyType = true;
            }
            if(this.types[i].propertyFields && this.types[i].propertyFields.indexOf('floorNumber') != -1){
              this.showFloorNumber = true;
            }
            if(this.types[i].propertyFields && this.types[i].propertyFields.indexOf('roomsCount') != -1){
              this.showRoomsCount = true;
            }
            if(this.types[i].propertyFields && this.types[i].propertyFields.indexOf('furnished') != -1){
              this.showFurnished = true;
            }

            // if(this.types[i].propertyFields && this.types[i].propertyFields.indexOf('buildNumber') != -1){
            //   this.showBuildNumber = true;
            // }
            // if(this.types[i].propertyFields && this.types[i].propertyFields.indexOf('floorsCount') != -1){
            //   this.showFloorsCount = true;
            // }


            // if(this.types[i].propertyFields && this.types[i].propertyFields.indexOf('bathrooms') != -1){
            //   this.showBathrooms = true;
            // }
            // if(this.types[i].propertyFields && this.types[i].propertyFields.indexOf('age') != -1){
            //   this.showAge = true;
            // }
          }
        }
      }
    },

    closePopup(){
      document.getElementById('selectRegion').style.display ='none';
    },
    exit(){
      document.getElementById('selectNeighborhoods').style.display ='none';
    },

    checkRegions(){
      if(!this.regionId){
        document.getElementById('selectRegion').style.display ='block';
      }
    },

    checkNeighborhoods(){
      if(!this.city){
        document.getElementById('selectNeighborhoods').style.display ='block';
      }
    },


  },
  created(){
    this.getDataInit();
    this.userLang = localStorage.getItem('lang') ?? 'ar';
  }
}
</script>